<template>
  <h1>FullReport</h1>

  <dev-panel>
    <div class="mt-2">
      <input-button state="dev" @click="loadFromAnswers">
        Submit answers to backend and generate report
      </input-button>
    </div>
    <div class="mt-2">
      <select v-model="considerationLevel" class="form-control">
        <option value="">
          (none)
        </option>
        <option :value="considerationLevels[0]">
          Green
        </option>
        <option :value="considerationLevels[1]">
          Yellow
        </option>
        <option :value="considerationLevels[2]">
          Red
        </option>
      </select>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="highRiskIndicator">
        High risk indicator ({{ highRiskIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="bddIndicator">
        BDD indicator ({{ bddIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="impulsivityIndicator">
        Impulsivity indicator ({{ impulsivityIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
  </dev-panel>

  <div v-if="loading" class="mt-4">
    Loading..
  </div>
  <div v-else class="mt-4">
    <full-report
      :consideration-level="considerationLevel"
      :high-risk-indicator="highRiskIndicator"
      :bdd-indicator="bddIndicator"
      :impulsivity-indicator="impulsivityIndicator"
      :advices="advices"
      :question-answers="questionAnswers"
    />
  </div>
</template>

<script>
import FullReport from '@/components/Report/FullReport';
import { CONSIDERATION_LEVEL_GREEN, CONSIDERATION_LEVEL_RED, CONSIDERATION_LEVEL_YELLOW } from '@/enum/ConsiderationLevel';
import InputButton from '@/components/Inputs/common/InputButton/InputButton';
import InputButtonToggle from '@/components/Inputs/common/InputButton/InputButtonToggle';
import DevComponentContainer from '@/components/DevComponent/DevComponentContainer';
import DevPanel from '@/components/DevComponent/DevPanel';

export default {
  name: 'FullReportDev',
  components: {
    DevPanel, InputButton, InputButtonToggle, FullReport,
  },
  extends: DevComponentContainer,
  data() {
    return {
      loading: false,

      considerationLevels: [CONSIDERATION_LEVEL_GREEN, CONSIDERATION_LEVEL_YELLOW, CONSIDERATION_LEVEL_RED],

      considerationLevel: CONSIDERATION_LEVEL_GREEN,
      highRiskIndicator: false,
      bddIndicator: false,
      impulsivityIndicator: false,

      advices: [
        {
          id: 'fake1',
          headline: 'Lorem ipsum',
          advice: 'Your answer about not being concerned about the risk of a new regret seems to indicate that you would benefit from reconsidering the risks involved in the cosmetic surgery/treatment you are now considering. Prefferably in dialogue with other people around you. Make sure you weigh up the expected benefits against the potential risks.',
        },
        {
          id: 'fake2',
          headline: 'Lorem ipsum',
          advice: 'Your answer about number of previous cosmetic surgeries/treatments indicate that you could benefit from reflecting on how your previous cosmetic interventions have impacted on your general well-being. And use such reflection actively as guide in relation to the cosmetic surgery/treatment you are now considering.',
        },
        {
          id: 'fake3',
          headline: 'Lorem ipsum',
          advice: 'Considering how unhappy you have been with the previous treatments, you would benefit from re-evaluating the cosmetic surgery/treatment you are now considering. This should include discussing with other people around you, and read more about the pros can cons of the procedure. Furthermore, put some serious thought into whether dissatisfaction with certain parts of you your body has now moved from one area to another (e.g.: from skin to nose)',
        },
        {
          id: 'fake4',
          headline: 'Lorem ipsum',
          advice: 'Since you have experienced extreme regrets related to previous cosmetic surgery/treatment, why are you now considering more cosmetic surgery/treatment? Ask this question not only to yourself, but also to people around you. Furthermore, put some serious thoughts into the likelihood of experiencing extreme regret yet again.',
        },
      ],

      questionAnswers: {
        108: [1, 2, 4, 5, 6, 7, 8, 11, 12, 13],
        109: [280],
        110: [282],
        113: [293],
        115: [298],
        116: [301],
        117: [307, 310],
        118: [314],
        119: [315],
        120: [317],
        121: [322],
        122: [326],
        123: [329],
        124: [333],
        126: [334],
        127: [342],
        128: [343],
        129: [350],
        130: [65],
        131: [355],
        132: [359],
        133: [362],
        134: [366],
        135: [373],
        136: [374, 375, 376, 377, 378, 379, 380, 381],
        137: [382],
        139: [389],
        140: [394],
        141: [395],
        142: [513],
        143: [404],
        144: [408],
        146: [416],
        148: [418],
        149: [424],
        150: [51],
        151: [426],
        154: [446],
        155: [447],
        156: [450],
        157: [453],
        158: [22],
        159: [456],
        160: [462],
        161: [466],
        162: [470],
        163: [473],
        164: [475, 476, 477, 478, 479],
        165: [483],
        166: [486],
        167: [67],
        168: [489],
        169: [496],
        170: [499],
        171: [506],
        172: [510],
      },
    };
  },
  methods: {
    loadFromAnswers() {
      this.loading = true;

      this.considerationLevel = '';
      this.highRiskIndicator = false;
      this.bddIndicator = false;
      this.impulsivityIndicator = false;
      this.advices = [];
      this.questionAnswers = {};

      this.$apiClient.survey.getRandomAnswers('main').then((questionAnswers) => {
        this.$apiClient.survey.submitAnswers('main', questionAnswers, true).then((submissionResult) => {
          this.considerationLevel = submissionResult.considerationLevel;
          this.highRiskIndicator = submissionResult.indicatorsActive.highRisk;
          this.bddIndicator = submissionResult.indicatorsActive.bdd;
          this.impulsivityIndicator = submissionResult.indicatorsActive.impulsivity;
          this.advices = submissionResult.advice;

          this.loading = false;
        });
      });
    },
  },
};
</script>
